var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCamera = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4.24992C0.75 3.60559 1.27233 3.08325 1.91667 3.08325H2.45895C2.84903 3.08325 3.2133 2.8883 3.42968 2.56374L3.90366 1.85277C4.12003 1.5282 4.4843 1.33325 4.87438 1.33325H7.12562C7.5157 1.33325 7.87997 1.5282 8.09634 1.85277L8.57032 2.56374C8.7867 2.8883 9.15097 3.08325 9.54105 3.08325H10.0833C10.7277 3.08325 11.25 3.60559 11.25 4.24992V9.49992C11.25 10.1442 10.7277 10.6666 10.0833 10.6666H1.91667C1.27233 10.6666 0.75 10.1442 0.75 9.49992V4.24992Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 6.58325C7.75 7.54975 6.9665 8.33325 6 8.33325C5.0335 8.33325 4.25 7.54975 4.25 6.58325C4.25 5.61675 5.0335 4.83325 6 4.83325C6.9665 4.83325 7.75 5.61675 7.75 6.58325Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCamera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/camera.a381d719.svg";
export { ForwardRef as ReactComponent };